module.exports = __webpack_public_path__ + "img/znd.51c44009.jpg";